import Vue from 'vue'
import ToastificationContent from '@/core/plugins/toastification/ToastificationContent.vue'

let channel = null
let channelNameBound = null
let initializedForChannel = false

function getFacilityId() {
  try {
    const raw = localStorage.getItem('Facility')
    if (!raw) return null
    const decoded = JSON.parse(atob(raw))
    if (decoded && typeof decoded === 'object' && decoded.id != null) return decoded.id
    if (typeof decoded === 'number') return decoded
    return null
  } catch (_) {
    return null
  }
}

function channelName(id) {
  return `officeVisit.${id}`
}

function unbindEvent() {
  if (channel) {
    try {
      channel.unbind('patientTimeExceededEvent')
    } catch (_) {}
  }
  initializedForChannel = false
}

/** Desuscribe canal global de alertas (p. ej. al cerrar sesión). */
export function teardownPatientVisitTimeExceededListener() {
  unbindEvent()
  try {
    if (channelNameBound && Vue.prototype.$pusher) {
      Vue.prototype.$pusher.unsubscribe(channelNameBound)
    }
  } catch (_) {}
  channel = null
  channelNameBound = null
}

export function initPatientVisitTimeExceededListener() {
  const pusher = Vue.prototype.$pusher
  if (!pusher || typeof pusher.subscribe !== 'function') return

  const facilityId = getFacilityId()
  if (facilityId == null) return

  const name = channelName(facilityId)

  // Misma instalación física tras elegir facility: la app recarga (DropdownFacility).
  if (initializedForChannel && channelNameBound === name && channel) return

  teardownPatientVisitTimeExceededListener()
  channelNameBound = name
  channel = pusher.subscribe(name)

  channel.bind('patientTimeExceededEvent', payload => {
    const ev = payload && typeof payload === 'object' && 'event' in payload ? payload.event : payload
    if (!ev || typeof ev !== 'object') return

    const mins = ev.minutes_open != null ? String(ev.minutes_open) : '—'
    const patient = ev.patient_name || 'Paciente'
    const doc = ev.doctor_name || '—'
    const chk = ev.checkin_time || '—'
    const fac = ev.facility_name || 'Facility'
    const oid = ev.office_visit_id != null ? String(ev.office_visit_id) : '—'

    const text =
      `${fac}: ${patient} lleva ${mins} min en visita (check-in ${chk}). ` +
      `Doctor: ${doc}. Visit #${oid}`

    if (typeof Vue.prototype.$toast !== 'function') return

    Vue.prototype.$toast(
      {
        component: ToastificationContent,
        props: {
          title: 'Tiempo de visita excedido',
          icon: 'fas fa-clock',
          text,
          variant: 'warning',
        },
      },
      {
        position: 'bottom-right',
        timeout: 9500,
      }
    )
  })

  initializedForChannel = true
}

export default {
  initPatientVisitTimeExceededListener,
  teardownPatientVisitTimeExceededListener,
}
